import React from 'react';

import { ModalName } from '@/shared/store/modals/constants';
/* @deprecated old modals that needs to be migrated */
import { CoinbaseNotInstalledModal } from '@/components/Modals/CoinbaseNotInstalledModal';
import { UnsupportedNetworkModal } from '@/components/Modals/UnsupportedNetworkModal';
import { OperationStatusModal } from '@/features/Modals/ui/OperationStatusModal';
import { RabbyNotInstalledModal } from '@/components/Modals/RabbyNotInstalledModal';
import { RegisterMarginAccountModal } from '@/components/Modals/RegisterMarginAccountModal';
import { MarginAccountDisconnectionModal } from '@/components/Modals/MarginAccountDisconnectionModal';
import {
    ActivateYourVaultModal,
    VaultActivationInProgressModal,
} from '@/components/Modals/VaultModals';
/* Migrated modals */
import {
    PoolsSupplyModal,
    PoolsWithdrawalModal,
    VaultsSupplyModal,
    VaultsWithdrawalModal,
    ConnectDAppModal,
    ConnectWalletModal,
    MarginAccountsVaultsSupplyModal,
    MarginAccountVaultsWithdrawalModal,
    BorrowModal,
    InviteMembersModal,
    ResendSelectedModal,
    CancelInvitesModal,
    //RemoveUserModal,
    ResendInviteModal,
    WalletInfoModal,
    MetamaskNotInstalledModal,
    ConfirmationTransactionModal,
} from '@/features/Modals';

export const modals = new Map([
    [ModalName.COINBASE_NOT_INSTALLED_MODAL, { modalComponent: <CoinbaseNotInstalledModal /> }],
    [ModalName.RABBY_NOT_INSTALLED_MODAL, { modalComponent: <RabbyNotInstalledModal /> }],
    [
        ModalName.UNSUPPORTED_NETWORK_MODAL,
        { modalComponent: <UnsupportedNetworkModal />, closable: false },
    ],
    [ModalName.BORROW_MODAL, { modalComponent: <BorrowModal />, className: 'min-w-[1000px]' }],
    [
        ModalName.WALLET_INFO_MODAL,
        { modalComponent: <WalletInfoModal />, defaultModalTitle: 'Account Settings' },
    ],
    [
        ModalName.OPERATION_STATUS_MODAL,
        {
            modalComponent: <OperationStatusModal />,
            className: 'operational',
            closable: true,
        },
    ],
    [
        ModalName.REGISTER_MARGIN_ACCOUNT_MODAL,
        {
            modalComponent: <RegisterMarginAccountModal />,
            closable: true,
            className: 'max-w-[580px]',
        },
    ],
    [
        ModalName.MA_DISCONNECTION,
        { modalComponent: <MarginAccountDisconnectionModal />, className: 'noTitleBorder' },
    ],
    [
        ModalName.CONFIRMATION_TRANSACTION_MODAL,
        { modalComponent: <ConfirmationTransactionModal /> },
    ],
    [ModalName.ACTIVATE_YOUR_VAULT_MODAL, { modalComponent: <ActivateYourVaultModal /> }],
    [
        ModalName.VAULT_IS_BEEN_ACTIVATED_MODAL,
        { modalComponent: <VaultActivationInProgressModal />, className: 'noTitleBorder' },
    ],
    // Migrated modals
    [ModalName.POOLS_SUPPLY_MODAL, { modalComponent: <PoolsSupplyModal /> }],
    [ModalName.VAULT_SUPPLY_MODAL, { modalComponent: <VaultsSupplyModal /> }],
    [ModalName.POOLS_WITHDRAWAL_MODAL, { modalComponent: <PoolsWithdrawalModal /> }],
    [ModalName.VAULT_WITHDRAWAL_MODAL, { modalComponent: <VaultsWithdrawalModal /> }],
    [
        ModalName.MARGIN_ACCOUNTS_VAULT_SUPPLY_MODAL,
        { modalComponent: <MarginAccountsVaultsSupplyModal /> },
    ],
    [
        ModalName.MARGIN_ACCOUNTS_VAULT_WITHDRAWAL_MODAL,
        { modalComponent: <MarginAccountVaultsWithdrawalModal /> },
    ],
    [
        ModalName.CONNECT_WALLET_MODAL,
        { modalComponent: <ConnectWalletModal />, defaultModalTitle: 'Connect Wallet' },
    ],
    [ModalName.CONNECT_DAPP, { modalComponent: <ConnectDAppModal /> }],
    [ModalName.METAMASK_NOT_INSTALLED_MODAL, { modalComponent: <MetamaskNotInstalledModal /> }],
    [ModalName.INVITE_MEMBERS_MODAL, { modalComponent: <InviteMembersModal /> }],
    [ModalName.RESEND_SELECTED, { modalComponent: <ResendSelectedModal /> }],
    [ModalName.CANCEL_INVITES, { modalComponent: <CancelInvitesModal /> }],
    //[ModalName.REMOVE_USER, { modalComponent: <RemoveUserModal /> }],
    [ModalName.RESEND_INVITE, { modalComponent: <ResendInviteModal /> }],
]);
